<div *ngIf="loading" class="spinner-container {{ spinnerSize }}" [class.overlay-background]="spinnerWithBackground">
  <alliance-icon [width]="spinnerSize === 'normal' ? 20 : 40" [name]="iconsMap[spinnerType][spinnerSize]"></alliance-icon>
</div>
